import React from 'react';
import { useTranslation } from 'react-i18next';
import { openDialog } from '@component/dialog';
import wemeetClient from '@utils/wemeetClient';
import { BOOL, HostKickOutReason } from '@tencent/wemeet-websdk-next';
import { openToast } from '@component/toast';
import { KickoutProps } from './Kickout.type';
import './Kickout.scss';

const CHECKBOX_KEY = 'notAllow';

const Kickout: React.FC<KickoutProps> = (props) => {
  const { t } = useTranslation();
  const onRemoveUser = () => {
    openDialog({
      dialogId: 'kickoutMeeting',
      title: t('移出会议'),
      content: t('确定将{#nickname#}移出会议？', { nickname: props.user.nickname }),
      checkboxConfig: [
        {
          name: CHECKBOX_KEY,
          checkboxText: t('不允许用户再次加入会议'),
        },
      ],

      btnConfigs: [
        {
          text: t('取消'),
        },
        {
          text: t('移出会议'),
          type: 'primary',
          callback: (checked) => {
            if (props.user.id) {
              wemeetClient.hostCtrl
                // 如果选中会有一个checked是一个非空数组
                .kickout(props.user.id, HostKickOutReason.normal, checked?.length > 0 ? BOOL.false : BOOL.true)
                .then(() => {
                  openToast(t('移出成功'));
                });
            }
          },
        },
      ],
    });
  };
  return (
    <li className="kickout" onClick={onRemoveUser}>
      {t('移出会议')}
    </li>
  );
};

export default Kickout;
